module.exports = __webpack_public_path__ + "img/new-job.b6dc6cdf.png";